var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 16.8755H11.125C10.78 16.8755 10.5 16.5955 10.5 16.2505C10.5 15.9055 10.5 4.09549 10.5 3.75049C10.5 3.40549 10.78 3.12549 11.125 3.12549H19.875C20.22 3.12549 20.5 3.40549 20.5 3.75049V16.2505C20.5 16.5955 20.22 16.8755 19.875 16.8755Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 6.87549H11.125C10.78 6.87549 10.5 6.59549 10.5 6.25049C10.5 5.90549 10.78 5.62549 11.125 5.62549H13.625C13.97 5.62549 14.25 5.90549 14.25 6.25049C14.25 6.59549 13.97 6.87549 13.625 6.87549Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 9.37549H11.125C10.78 9.37549 10.5 9.09549 10.5 8.75049C10.5 8.40549 10.78 8.12549 11.125 8.12549H13.625C13.97 8.12549 14.25 8.40549 14.25 8.75049C14.25 9.09549 13.97 9.37549 13.625 9.37549Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 11.8755H11.125C10.78 11.8755 10.5 11.5955 10.5 11.2505C10.5 10.9055 10.78 10.6255 11.125 10.6255H13.625C13.97 10.6255 14.25 10.9055 14.25 11.2505C14.25 11.5955 13.97 11.8755 13.625 11.8755Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 14.3755H11.125C10.78 14.3755 10.5 14.0955 10.5 13.7505C10.5 13.4055 10.78 13.1255 11.125 13.1255H13.625C13.97 13.1255 14.25 13.4055 14.25 13.7505C14.25 14.0955 13.97 14.3755 13.625 14.3755Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 6.87549H16.125C15.78 6.87549 15.5 6.59549 15.5 6.25049C15.5 5.90549 15.78 5.62549 16.125 5.62549H17.375C17.72 5.62549 18 5.90549 18 6.25049C18 6.59549 17.72 6.87549 17.375 6.87549Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 9.37549H16.125C15.78 9.37549 15.5 9.09549 15.5 8.75049C15.5 8.40549 15.78 8.12549 16.125 8.12549H17.375C17.72 8.12549 18 8.40549 18 8.75049C18 9.09549 17.72 9.37549 17.375 9.37549Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 11.8755H16.125C15.78 11.8755 15.5 11.5955 15.5 11.2505C15.5 10.9055 15.78 10.6255 16.125 10.6255H17.375C17.72 10.6255 18 10.9055 18 11.2505C18 11.5955 17.72 11.8755 17.375 11.8755Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 14.3755H16.125C15.78 14.3755 15.5 14.0955 15.5 13.7505C15.5 13.4055 15.78 13.1255 16.125 13.1255H17.375C17.72 13.1255 18 13.4055 18 13.7505C18 14.0955 17.72 14.3755 17.375 14.3755Z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5238 0.769104C11.3813 0.650354 11.19 0.599104 11.01 0.636604L1.01 2.5116C0.71375 2.5666 0.5 2.8241 0.5 3.12535V16.8754C0.5 17.1754 0.71375 17.4341 1.01 17.4891L11.01 19.3641C11.0475 19.3716 11.0863 19.3754 11.125 19.3754C11.27 19.3754 11.4113 19.3254 11.5238 19.2316C11.6675 19.1129 11.75 18.9354 11.75 18.7504V1.25035C11.75 1.0641 11.6675 0.887854 11.5238 0.769104Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09491 12.0891L7.11866 9.83037L9.11741 7.26037C9.32991 6.98787 9.27991 6.59537 9.00866 6.38287C8.73741 6.17037 8.34491 6.22037 8.13116 6.49162L6.27991 8.87162L4.71991 7.08912C4.49116 6.82662 4.09616 6.80287 3.83866 7.03037C3.57866 7.25787 3.55241 7.65287 3.77991 7.91162L5.49866 9.87662L3.75616 12.1166C3.54366 12.3891 3.59366 12.7816 3.86491 12.9941C3.97991 13.0829 4.11616 13.1254 4.24991 13.1254C4.43616 13.1254 4.61991 13.0429 4.74366 12.8841L6.33741 10.8341L8.15491 12.9104C8.27866 13.0529 8.45116 13.1254 8.62491 13.1254C8.77116 13.1254 8.91741 13.0741 9.03616 12.9704C9.29616 12.7429 9.32241 12.3479 9.09491 12.0891Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_2116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.1f51c40b3661c0bc97c0f2026df710ae.svg";
export { ForwardRef as ReactComponent };